/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetModuleWorkingModeDiffTarget =
  (typeof GetModuleWorkingModeDiffTarget)[keyof typeof GetModuleWorkingModeDiffTarget];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetModuleWorkingModeDiffTarget = {
  custom: 'custom',
  classic_essays: 'classic_essays',
  ai_tutor_oral: 'ai_tutor_oral',
} as const;
